import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message, Modal, Tooltip } from '@/components';
import { RootStore } from '@/models';
import { ActionProps } from '../ActionBtn';
import styles from './index.less';
import { requestRecording } from '@/api';
import classNames from 'classnames';
import { elkLog } from '@/utils/elkReport';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  meeting?: RootStore['meeting'];
  className?: string;
}
const RecordingBtn: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { meeting } = props;
    const { formatMessage } = useIntl();

    const requestRecordingClick = useCallback(() => {
      elkLog('点击录制按钮');
      if (!meeting?.hostUid) {
        message.info({
          content: formatMessage({ id: 'RECORDING_CANNOT_BE_STARTED' }),
          noIcon: true,
        });
        return;
      }
      if (meeting?.videoRecordingState !== 3) {
        return;
      }
      // closeShowMoreClick();
      function send() {
        meeting?.info?.channelId &&
          requestRecording(meeting?.info?.channelId).then((res) => {
            if (res.status === 1) {
              message.info({
                content: formatMessage({ id: 'REQUEST_SENT' }),
                icon: null,
              });
              elkLog('发送录制请求成功');
            }
          });
      }
      Modal.confirm({
        focusTriggerAfterClose: false,
        title: (
          <span className={styles.modalWrapper}>
            <span className={styles.title}>{formatMessage({ id: 'REQUEST_RECORDING' })}</span>
          </span>
        ),
        okText: formatMessage({ id: 'CONFIRM' }),
        cancelText: formatMessage({ id: 'CANCEL' }),
        okButtonProps: {
          className: `popo-meeting-button`,
        },
        onOk: send,
      });
    }, [meeting?.videoRecordingState, meeting?.hostUid]);

    const recordBtnTip = useMemo(() => {
      if (!meeting?.hostUid) return formatMessage({ id: 'RECORDING_CANNOT_BE_STARTED' });
      switch (meeting?.videoRecordingState) {
        case 1:
          return formatMessage({ id: 'RECORDING2' });
        case 2:
          return formatMessage({ id: 'RECORDING_PAUSED' });
        case 3:
        default:
          return formatMessage({ id: 'REQUEST_RECORDING2' });
      }
    }, [meeting?.videoRecordingState, meeting?.hostUid, meeting?.hostUid]);

    if (!meeting?.ableAppsMap.WebRecording) {
      return null;
    }

    return (
      <Tooltip title={recordBtnTip} className={classNames(styles.recordingBtn, {})}>
        <div
          className={classNames(styles.recording, {
            [styles.disable]: !meeting?.hostUid || meeting?.videoRecordingState !== 3,
          })}
          onClick={requestRecordingClick}
        >
          <Icon className={styles.icon} name="icon-luzhi" />
          <span className={styles.title}>{formatMessage({ id: 'RECORD' })}</span>
        </div>
      </Tooltip>
    );
  })
);

export default RecordingBtn;
